/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, ViewEncapsulation} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';

import template from './base-new-button.component.html';
import {AppShellStateService} from '../app-shell-state.service';
import {APP_SHARED} from '../../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule, BsDropdownModule],
  selector: 'adn-base-new-button',
  template,
  encapsulation: ViewEncapsulation.None
})
export class BaseNewButtonComponent {
  constructor(readonly shell: AppShellStateService) {
  }

  loadExternalLineItem(): void {
    this.shell.loadExternalLineItem();
  }
}
